class CrowdfundingPeriod {
    release;
    formal;
    constructor(data) {
        this.release = data.release;
        this.formal = data.formal;
    }
}
export default CrowdfundingPeriod;
